<template>
    <div>
        <div v-for="(system, index) in systems.$each.$iter" :key="system.$model.uid" class="mb-lg">
            <p class="flex justify-between h4 mb-lg">
                Inverter {{ index | counter }}
                <button v-if="systems.$model.length > 1" class="remove flex items-center" @click.prevent="removeSystem(system.$model.uid)">
                    <svg class="icon"><use xlink:href="#remove" /></svg>
                    <span class="small semi text--orange">Remove</span>
                </button>
            </p>

            <div class="fields">
                <FieldSelect
                    :value="system.$model.inverter"
                    :options="inverters"
                    class="field--full"
                    label="Select product"
                    placeholder="Select product"
                    :select-options="{
                        selectable: (o) => o.valid == 1 && o.details.numberOfPhases <= noOfPhases,
                        getOptionLabel: createPanelLabel,
                        noOptionsText: 'Fetching products...'
                    }"
                    :v="system"
                    @input="updateSystem({ id: system.$model.id, inverter: $event })"
                >
                    <template v-slot:vSelectOption="option">
                        <em :class="{'no-selectable': !option.valid || option.details.numberOfPhases > noOfPhases}">
                            {{ option.manufacturer }} - {{ option.model }}
                            <svg v-if="!option.valid" class="icon"><use xlink:href="#alert" /></svg>
                        </em>
                    </template>
                </FieldSelect>
            </div>
            <div v-if="system.$model.inverter && system.$model.inverter.details.inverterType == 'string'" class="field checkboxes checkboxes--inline field--full" :class="{ 'checkboxes--disabled': !system.$model.inverter }">
                <div class="input">
                    <label>
                        <input type="checkbox" :checked="system.$model.dcu" @input="updateSystem({ id: system.$model.id, dcu: $event.target.checked })">
                        <span />
                        DC optimisers
                    </label>
                </div>
            </div>
        </div>

        <button :disabled="!canAddNew" class="add-another mb-xl" @click.prevent="addSystem">
            <span class="iconlink add-another__icon">
                <svg class="icon"><use xlink:href="#add" /></svg>
            </span>
            <span class="add-another__text small semi">Add another inverter</span>
        </button>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FieldSelect from '@/form/Select';

export default {
    components: {
        FieldSelect,
    },

    filters: {
        counter(num) {
            return Number(num) + 1;
        }
    },

    props: {
        systems: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapState('products', ['inverters']),
        ...mapState('job', ['noOfPhases']),

        canAddNew() {
            return !this.systems.$invalid && this.systems.$model.length < 6;
        }
    },

    methods: {
        ...mapActions('configuration', ['addSystem', 'updateSystem', 'removeSystem']),

        createPanelLabel(option) {
            return `${option.manufacturer} - ${option.model}`;
        },
    },
};
</script>

<style lang="scss" scoped>
    .flex {
        display: flex;
    }

    .items-center {
        align-items: center;
    }

    .justify-between {
        justify-content: space-between;
    }

    .remove {
        .icon {
            margin-right: 0.3em;
        }
    }

    .no-selectable {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #AFAFAF;
        font-style: normal;

        svg * {
            color: #EF6E0B !important;
        }
    }
</style>
